// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kGdSl","left":"styles_left__1qg6p"};